// extracted by mini-css-extract-plugin
export default {"commission-modal":"commission-modal","info-text":"info-text","commission-modal-web":"commission-modal-web"};